const useResponseHandler = ({
    requestHandler,
    payload = {},
    authHandler = () => {},
}) => {
    const handleResponse = async (payloadArgs) => {
        const response = await requestHandler({
            ...payload,
            ...payloadArgs,
        });
        const json = await response.json();

        if (json.statusCode === 401) {
            authHandler(response);
        }

        if (!json.success) {
            throw Error(json.errorMessage);
        }
        return json.data;
    };

    return { handleResponse };
};

export default useResponseHandler;
